import { useOrganisation } from '@/app/redux/hooks/organisation';
import { getSeatLimitStatus, isLimitedPlan } from '@/common/utils/license';
import {
  SectionContainer,
  SectionContent,
  SectionHeader,
} from '@/dashboard/SettingsView/Billing/BillingPageStyles';
import { StudentIcon } from '@phosphor-icons/react';
import { cn } from '@shadcn/lib/utils';
import { useMemo } from 'react';

export default function UsageDetails() {
  const { organisation } = useOrganisation();

  const studentCount = organisation?.studentCount ?? 0;
  const license = organisation?.license;
  const seatCount = license?.seatCount ?? 0;
  const licensePlan = license?.plan ?? 'trial';

  const seatLimitStatus = useMemo(() => {
    return getSeatLimitStatus(
      organisation?.license,
      organisation?.studentCount,
    );
  }, [organisation]);

  return (
    <SectionContainer>
      <SectionHeader>
        <span className="font-medium text-lg">Usage</span>
        <span className="text-sm text-muted-foreground">
          Monitor your learner accounts
        </span>
      </SectionHeader>

      <SectionContent>
        <div className="flex items-center gap-2">
          <StudentIcon size={24} />
          <span
            className={cn(
              (seatLimitStatus === 'over-limit' ||
                seatLimitStatus === 'grace-ended') &&
                'text-warning',
            )}
          >
            {studentCount} /{' '}
            {isLimitedPlan(licensePlan) || licensePlan === 'free'
              ? seatCount
              : '∞'}
          </span>
        </div>

        <div className="w-full h-2 rounded-full bg-muted mb-2">
          {isLimitedPlan(licensePlan) ? (
            <div
              className={cn(
                'h-full bg-primary rounded-full',
                (seatLimitStatus === 'over-limit' ||
                  seatLimitStatus === 'grace-ended') &&
                  'bg-warning',
              )}
              style={{
                width: `${Math.min((studentCount / seatCount) * 100, 100)}%`,
              }}
            />
          ) : (
            <div
              className={cn(
                'h-full bg-primary rounded-full w-0',
                studentCount > 0 && 'w-4',
              )}
            />
          )}
        </div>
      </SectionContent>
    </SectionContainer>
  );
}
